/**
 * Shared layout + typography helpers for legal / policy pages.
 * Keeps Terms, Privacy, Refund, Disclaimer visually consistent.
 */
import PublicLayout from "@/components/PublicLayout";

export const LegalHero = ({ eyebrow, title, subtitle, updated }) => (
  <div className="border-b border-[#1F1F1F] bg-gradient-to-b from-[#141414] to-[#0A0A0A]">
    <div className="max-w-3xl mx-auto px-6 md:px-8 py-14 md:py-20">
      <div className="kpi-label mb-3">/ {eyebrow}</div>
      <h1 className="font-display text-4xl md:text-5xl tracking-tighter text-white leading-[1.05]">
        {title}
      </h1>
      {subtitle && (
        <p className="text-[15px] text-[#A3A3A3] mt-5 max-w-2xl leading-relaxed">{subtitle}</p>
      )}
      {updated && (
        <div className="mt-6 text-[11px] font-mono-data tracking-wider uppercase text-[#525252]">
          Last updated · {updated}
        </div>
      )}
    </div>
  </div>
);

export const LegalSection = ({ id, title, children }) => (
  <section id={id} data-testid={`legal-section-${id}`} className="scroll-mt-20 mb-12">
    <h2 className="font-display text-xl md:text-2xl text-white tracking-tight mb-4">{title}</h2>
    <div className="space-y-4 text-[14px] text-[#D4D4D4] leading-[1.75]">{children}</div>
  </section>
);

export const LegalList = ({ items }) => (
  <ul className="space-y-2.5 pl-1">
    {items.map((item, i) => (
      <li key={i} className="flex gap-3">
        <span className="kpi-label text-[#525252] mt-1 shrink-0">·</span>
        <span className="text-[#D4D4D4]">{item}</span>
      </li>
    ))}
  </ul>
);

export default function LegalLayout({ children }) {
  return (
    <PublicLayout>
      <article className="max-w-3xl mx-auto px-6 md:px-8 py-12 md:py-16">{children}</article>
    </PublicLayout>
  );
}
